import React from "react";

import HStackSvg from "../../assets/images/icons/Form Controls/Horizontal stack container.svg";

export const HStackIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={HStackSvg}
        alt={alt || "Horizontal Stack Container"}
    />
);
